import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';
export const AddFieldButton = ({ children, ...props }) => (_jsxs(Button, { size: "sm", fontSize: 16, variant: "subtle", borderRadius: "md", ...props, children: [_jsx(FaPlus, {}), children] }));
